import { defineMessages } from 'react-intl';

export default defineMessages({
  accountConfirmed: {
    id: 'Your account has been confirmed successfully!',
    defaultMessage: 'Your account has been confirmed successfully!'
  },
  attention: {
    id: 'Attention! = D',
    defaultMessage: 'Attention! = D'
  },
  bye: {
    id: 'Goodbye',
    defaultMessage: 'Goodbye'
  },
  byeDetails: {
    id: 'See you soon!',
    defaultMessage: 'See you soon!'
  },
  completeYourProfile: {
    id: 'Complete your profile to have a better experience on our platform',
    defaultMessage: 'Complete your profile to have a better experience on our platform'
  },
  confirmationEmailSent: {
    id: 'An email has been sent to {email} to confirm your account. Please check your inbox',
    defaultMessage: 'An email has been sent to {email} to confirm your account. Please check your inbox'
  },
  done: {
    id: 'Ready! =D',
    defaultMessage: 'Ready! =D'
  },
  error: {
    id: 'We have a problem! =(',
    defaultMessage: 'We have a problem! =('
  },
  expiredTokenAccountConfirmation: {
    id: 'The confirmation token is expired. Please request a new token to activate your account.',
    defaultMessage: 'The confirmation token is expired. Please request a new token to activate your account.'
  },
  hello: {
    id: 'Hello, welcome!',
    defaultMessage: 'Hello, welcome!'
  },
  readyToNavigate: {
    id: 'You can browse all the courses.',
    defaultMessage: 'You can browse all the courses.'
  },
  passwordUpdated: {
    id: 'Your password has been changed. You can reconnect now!',
    defaultMessage: 'Your password has been changed. You can reconnect now!'
  },
  welcome: {
    id: 'Welcome',
    defaultMessage: 'Welcome'
  },
  linkProviderSuccess: {
    id: 'Success in linking your {provider} account!',
    defaultMessage: 'Success in linking your {provider} account!'
  },
  unlinkProviderSuccess: {
    id: 'Unlinking from {provider}!',
    defaultMessage: 'Unlinking from {provider}!'
  },
  networkError: {
    id: 'Could not establish connection',
    defaultMessage: 'Could not establish connection'
  },
});
